import * as actions from "./actions.js";
import mutations from "./mutations.js";
import state from "./state.js";

export default {
  namespaced: true,
  state: state(),
  actions,
  mutations,
};
